'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from 'react';
export const useDropdown = t0 => {
  const $ = _c(5);
  const initialOpen = t0 === undefined ? false : t0;
  const [open, setOpen] = useState(initialOpen);
  const ref = useRef(null);
  let t1;
  let t2;
  if ($[0] !== open) {
    t1 = () => {
      if (!open) {
        return;
      }
      const handleClickOutside = event => {
        if (ref.current && !ref.current.contains(event.target as Node)) {
          setOpen(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    };
    t2 = [open];
    $[0] = open;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== open) {
    t3 = {
      open,
      setOpen,
      ref
    };
    $[3] = open;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};